import React, {
    useCallback,
    useState,
    useContext,
    useMemo,
    useEffect,
} from 'react';
import { useCookies } from 'react-cookie';
import { useMediaQuery } from 'react-responsive';

import AutoBidForm from 'components/auctions/AuctionVehicleCard/Footer/BidsForm/AutoBidForm';
import Traductor from 'components/Traductor';

import SellService from 'services/SellService';
import VehicleService from 'services/VehicleService';
import { UserContext } from 'contexts/UserContext';

import Globals from '../../../../../Globals';
import { formatNumber } from 'js/components/shared/vehicleFunctions';

const VehicleExportModality = ({
    vehicle,
    setLoadingParent,
    disableButtons,
    updateVehiclesList,
    options,
    disabled,
    loading,
}) => {
    const [offerAmount, setOfferAmount] = useState('');
    const [cookies] = useCookies([Globals.COOKIES]);
    const t = useMemo(() => new Traductor(), []);
    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const { user } = useContext(UserContext);
    const onOffer = useCallback(async () => {
        if (!offerAmount) return;
        try {
            disableButtons(true);
            const formattedOffer = offerAmount
                .replace('.', '')
                .replace(',', '.');
            const res = await new SellService().insertExportOffer(
                {
                    Price: formattedOffer,
                    WebSalesId: vehicle?.WebSalesId,
                    ClientId: user?.preferredLocation?.ClientId,
                },
                cookies?.[Globals.COOKIES.JWT]?.AccessToken
            );
            if (res?.body?.Result) {
                updateVehiclesList({
                    WebSalesId: vehicle?.WebSalesId,
                    CurrentOffer: formattedOffer,
                });
                setOfferAmount('');
            }
        } catch (error) {
            console.log(error);
        } finally {
            disableButtons(false);
        }
    }, [
        cookies,
        disableButtons,
        offerAmount,
        updateVehiclesList,
        user?.preferredLocation?.ClientId,
        vehicle.WebSalesId,
    ]);

    const validateInputDecimals = useCallback(value => {
        if (!value) setOfferAmount(value);
        let decimals = '';
        const comma = value.indexOf(',');
        if (comma !== -1) {
            decimals = value.slice(comma, comma + 3).replace(/[^\d]/g, '');
        }
        setOfferAmount(
            `${value.slice(
                0,
                comma !== -1 ? comma + 1 : value.length
            )}${decimals}`
        );
    }, []);

    useEffect(() => {
        (async function getCurrentExportOffer() {
            const response = await new VehicleService().getCurrentExportOffer(
                vehicle?.WebSalesId,
                cookies?.[Globals.COOKIES.JWT]?.AccessToken
            );
            updateVehiclesList({
                WebSalesId: vehicle?.WebSalesId,
                CurrentOffer: response?.body?.Result,
            });
            setLoadingParent(false);
            disableButtons(false);
            try {
            } catch (error) {
                console.log(error);
            }
        })();
    }, [
        setLoadingParent,
        disableButtons,
        vehicle?.WebSalesId,
        cookies,
        updateVehiclesList,
    ]);

    const parseAmount = amount => {
        return parseFloat(amount)
            ? `${formatNumber(
                  parseFloat(amount).toFixed(2).replace('.', ',')
              )}€`
            : '-';
    };

    const marginTopNone = options.type === 'detailvehicle' ? 'u-mt-none' : '';
    return (
        <>
            <hr />
            <div className={`${isMobile ? 'u-ph-small' : 'u-ph'}`}>
                <div className="u-1/2 u-inline-item">
                    <p>{t.getTraduction('PriceReference')}</p>
                    <p className="u-text-bold">
                        {parseAmount(vehicle?.MinimumPrice)}
                    </p>
                </div>
                <div className="u-1/2 u-inline-item">
                    <p>{t.getTraduction('YourOffer')}</p>
                    <p className="u-text-bold">
                        {parseAmount(vehicle?.CurrentOffer)}
                    </p>
                </div>
            </div>
            <AutoBidForm
                marginTop={marginTopNone}
                onBid={onOffer}
                disabled={disabled}
                loading={loading}
                vehicle={vehicle}
                type={options.type}
                inputAmount={offerAmount}
                onInputAmountChange={validateInputDecimals}
                options={{
                    label: t.getTraduction('OfferAmount'),
                    button: t.getTraduction('Offer'),
                    disabledButton: !parseFloat(
                        offerAmount
                    ) /*||
                        parseFloat(vehicle?.CurrentOffer) >=
                            parseFloat(
                                offerAmount.replace('.', '').replace(',', '.')
                            )*/,
                    inputRegex: /[^\d.,]/g,
                }}
            />
        </>
    );
};

export default VehicleExportModality;
